import $ from 'jquery';

export const eventClickPauActions = ( e ) => {

    e.preventDefault();

    let $pauMainAcces       = $( "#pauMainAcces" ),
        dataUrl             = $pauMainAcces.attr( "data-url" ),
        mediaDirHeader      = dataUrl + "multimedia/pau/react/header/",
        $pauBackMain        = $( '#pauBackMain' ),
        $iconPauAcces       = $( '.iconPauAcces' ),
        $iconPauAccesimg    = $( '.iconPauAcces img' ),
        $pauReactMenus      = $( '.pauReactMenus li a img' ),
        $panelActions       = $( '.panelActions > div' ),
        $pauContMain        = $( '#pauContMain' ),
        $pauContPanel       = $( '#pauContPanel' ),
        pauContMain         = parseInt( $pauContMain.attr( "data-value" ), 10 ),
        pauContPanel        = parseInt( $pauContPanel.attr( "data-value" ), 10 ),
        $target             = $( e.target ),
        dataKey             = $target.attr( "data-key" );

    // console.log( dataKey );

    switch( dataKey ) {

        case "iconPauAcces" :

            $pauReactMenus.parent().removeClass( "active" );

            if( pauContMain === 1 ) {

                $pauMainAcces.animate({
                    right: '-380px'
                });

                $iconPauAcces.css({
                    "width"         : "80px",
                    "height"        : "80px",
                    "padding"       : "5px",
                    "background"    : "#010066"
                });

                $iconPauAccesimg.attr( "src", mediaDirHeader + "ico-pau.svg" );

                $pauBackMain.show();

                $pauContMain.attr( "data-value", 0 );

            } else if( pauContMain === 0 ) {

                $pauContMain.attr( "data-value", 1 );

                $pauMainAcces.animate({
                    right: '-450px'
                });

                $iconPauAcces.css({
                    "width"         : "80px",
                    "height"        : "80px",
                    "padding"       : "0",
                    "background"    : "transparent"
                });
                $iconPauAccesimg.attr( "src", mediaDirHeader + "ico-principal-pau.svg" );


                $pauBackMain.hide();

            }

            break;

        case "pauReactMenus" :

            if( pauContPanel === 1 ) {

                $pauMainAcces.animate({
                    right: '0'
                });

                $pauContMain.attr( "data-value", 0 );

            }

            let target  = $target.parent().attr( "href" );

            // console.log( target );

            $pauReactMenus.parent().removeClass( "active" );
            $target.parent().addClass( "active" );

            $panelActions.hide();
            // console.log( $panelActions );
            $( target ).show();

            break;

        case "pauBackMain" :

            $pauReactMenus.parent().removeClass( "active" );

            pauContMain = 1;

            $pauBackMain.hide();

            $pauMainAcces.animate({
                right: '-430px'
            });

            break;

    }

};



// WEBPACK FOOTER //
// ./src/assets/js/MenuPauPrincipal.js